export default __webpack_public_path__ + "static/media/white-prev-arrow.51878e0c.svg";